import request from '@/utils/request';
export function countTodayAlarm(data) {
  return request({
    url: '/pmsdevice/api/homePage/countTodayAlarm',
    method: 'get',
    params: data
  });
} // 设备告警15天

export function halfMonthAlarm(data) {
  return request({
    url: '/pmsservice/api/spot/deviceDayList',
    method: 'post',
    params: data
  });
} // 车辆进出15天

export function halfMonthVehicle(data) {
  return request({
    url: '/pmsservice/api/spot/parkingDayList',
    method: 'post',
    params: data
  });
} // 获取设备监控数据

export function countDeviceBySys(data) {
  return request({
    url: '/pmsdevice/api/homePage/countDeviceBySys',
    method: 'get',
    params: data
  });
}
export function fetchthisTime() {
  return request({
    url: '/auth/thisTime',
    method: 'get'
  });
}
export function fetchCommunityData() {
  return request({
    url: '/pmsservice/api/homeCountService/get',
    method: 'post'
  });
}
export function getInfoByCommunityId(data) {
  return request({
    url: '/pmsservice/api/managerAreaOa/getInfoByCommunityId',
    method: 'post',
    data: data
  });
} // 待处理报修数 待处理投诉数 待处理任务数 待处理工单数

export function fetchOrderStatistics(data) {
  return request({
    url: '/pmsdevice/api/homePage/getStatic',
    method: 'post',
    data: data
  });
}
export function fetchRepairList(data) {
  return request({
    url: '/pmsdevice/api/homePage/listRepair',
    method: 'post',
    data: data
  });
}
export function fetchTaskList(data) {
  return request({
    url: '/pmsdevice/api/homePage/listTask',
    method: 'post',
    data: data
  });
}
export function fetchComplainList(data) {
  return request({
    url: '/pmsdevice/api/homePage/listComplain',
    method: 'post',
    data: data
  });
}
export function fetchChargeList(data) {
  return request({
    url: '/pmsdevice/api/homePage/listCharge',
    method: 'post',
    data: data
  });
}